<ng-template [ngIf]="item">
    <a
      prefetch="intent"
      [routerLink]="linkCommands"
      [queryParams]="{ variantid: variantId }"
      [state]="{ from: currentUrl }"
      [ngStyle]="backgroundColor ? {'background-color': backgroundColor} : {}"
      class="group block roundedClass border border-transparent p-4 md:px-6 md:py-7 transition
             hover:border-gray-200 hover:shadow-lg"
    >
      <div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2">

        <div class="min-w-0 py-4 md:py-8">
          <h3
            class="line-clamp-2 max-w-[240px] md:max-w-[270px] text-[#2E3742] font-bold text-lg leading-snug tracking-tight"
            [title]="itemName"
          >
            {{ itemName }}
          </h3>

          <p
            *ngIf="displaySubtitle"
            class="mt-1 text-orange-500 text-sm leading-relaxed line-clamp-1"
            [title]="item.productSubtitle"
          >
            {{ item.productSubtitle }}
          </p>

          <div *ngIf="displayPrice" class="mt-16 text-[#2E3742]">
            <ng-container *ngIf="msrp && itemPrice && msrp > itemPrice; else onlyPrice">
              <span class="text-sm text-gray-400 line-through">{{ msrp | formatPrice }}</span>
              <span class="ml-2 font-semibold">{{ itemPrice | formatPrice }}</span>
              <span *ngIf="discountPercentage" class="ml-2 text-sm text-rose-600">
                ({{ discountPercentage | number:'1.0-0' }}% off)
              </span>
            </ng-container>
            <ng-template #onlyPrice>
              <span class="font-semibold">
                <ng-container [ngSwitch]="item.price.__typename">
                  <ng-container *ngSwitchCase="'SinglePrice'">{{ itemPrice | formatPrice }}</ng-container>
                  <ng-container *ngSwitchCase="'PriceRange'">
                    <ng-container *ngIf="item.price.min === item.price.max; else range">
                      {{ itemPrice | formatPrice }}
                    </ng-container>
                    <ng-template #range>From {{ item.price.min | formatPrice }}</ng-template>
                  </ng-container>
                </ng-container>
              </span>
            </ng-template>
          </div>

          <div *ngIf="displayBuyButton" class="mt-2">
            <button
              (click)="onButtonClick($event)"
              [disabled]="isDisabled"
              class="px-4 py-1 whitespace-nowrap rounded-lg border focus:outline-none pointer-events-auto"
              [ngClass]="defaultButtonClasses"
              [ngStyle]="buttonInlineStyle"
            >
              {{ inStock ? resolvedButtonText : 'Sold Out' }}
            </button>
          </div>
        </div>

        <div class="relative h-full aspect-[22/29] overflow-hidden roundedClass">
          <img
            *ngIf="featuredAsset && !featuredAsset?.videoUrl"
            [src]="featuredAsset | assetPreview:'medium':'webp'"
            [alt]="itemName"
            class="absolute inset-0 h-full object-cover drop-shadow-lg"
          />
        </div>
      </div>
    </a>
</ng-template>
